import { X, Trophy, Target, TrendingUp } from "lucide-react";

const money = (n: number) =>
  n >= 1000 ? `$${(n / 1000).toFixed(n % 1000 === 0 ? 0 : 1)}k` : `$${Math.round(n || 0)}`;

export function MonthlyAchievementModal({
  data,
  onClose,
}: {
  data: any;
  onClose: () => void;
}) {
  const prev = data?.prevMonth;
  const achieved = prev?.status === "Target Achieved";
  const missed = prev?.status === "Target Missed";

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div className="bg-surface-container-lowest w-full max-w-md rounded-2xl shadow-2xl overflow-hidden">
        <div className={`px-6 py-5 text-white ${achieved ? "bg-gradient-to-br from-[#10b981] to-[#0f8a63]" : missed ? "bg-gradient-to-br from-error to-[#b3261e]" : "bg-gradient-to-br from-primary to-[#0b5fd6]"}`}>
          <div className="flex items-start justify-between">
            <div>
              <p className="text-[11px] uppercase tracking-wider font-bold opacity-80">Monthly Report</p>
              <h2 className="text-xl font-bold mt-0.5 flex items-center gap-2">
                {achieved ? <Trophy size={20} /> : <TrendingUp size={20} />} {prev?.label || "Previous Month"}
              </h2>
            </div>
            <button onClick={onClose} className="p-1 rounded-full hover:bg-white/20"><X size={18} /></button>
          </div>
        </div>

        <div className="p-6 space-y-4">
          {prev?.target > 0 ? (
            <>
              <div className="grid grid-cols-3 gap-2 text-center">
                <div className="rounded-lg bg-surface-container-low p-3">
                  <div className="text-[10px] uppercase text-on-surface-variant font-semibold">Target</div>
                  <div className="text-lg font-bold text-on-surface mt-0.5">{money(prev.target)}</div>
                </div>
                <div className="rounded-lg bg-surface-container-low p-3">
                  <div className="text-[10px] uppercase text-on-surface-variant font-semibold">Achieved</div>
                  <div className="text-lg font-bold text-on-surface mt-0.5">{money(prev.achieved)}</div>
                </div>
                <div className="rounded-lg bg-surface-container-low p-3">
                  <div className="text-[10px] uppercase text-on-surface-variant font-semibold">Progress</div>
                  <div className={`text-lg font-bold mt-0.5 ${achieved ? "text-[#0f8a63]" : "text-error"}`}>{prev.pct}%</div>
                </div>
              </div>
              <div className={`text-center py-2 rounded-lg font-bold text-sm ${achieved ? "bg-[#10b981]/15 text-[#0f8a63]" : "bg-error-container text-error"}`}>
                {achieved ? "🏆 Target Achieved!" : "🔴 Target Missed"}
              </div>
              {prev.bonus && (
                <div className="text-center text-[13px] text-on-surface-variant">
                  Bonus unlocked: <span className="font-bold text-on-surface">{prev.bonus.tierName}</span>{" "}
                  ({prev.bonus.bonusType === "Percentage" ? `${prev.bonus.bonusValue}%` : `${prev.bonus.bonusValue}`})
                </div>
              )}
            </>
          ) : (
            <p className="text-center text-on-surface-variant text-sm">No target was set for {prev?.label}.</p>
          )}

          <div className="border-t border-outline-variant pt-4 flex items-center justify-between">
            <span className="text-[13px] text-on-surface-variant flex items-center gap-1.5">
              <Target size={15} className="text-primary" /> {data?.newMonthLabel} target
            </span>
            <span className="text-lg font-bold text-primary">
              {data?.newTarget > 0 ? money(data.newTarget) : "Not set"}
            </span>
          </div>
        </div>

        <div className="px-6 py-4 border-t border-outline-variant">
          <button
            onClick={onClose}
            className="w-full py-2.5 rounded-lg bg-primary text-white font-semibold text-sm hover:bg-[#004b9e] transition-colors"
          >
            Got it — start the new month
          </button>
        </div>
      </div>
    </div>
  );
}
